window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSuperbombaNagradaRepo = function () {
    var url = 'api/casinosuperbombanagrada';

    var get = function (bonusAktivacijaId, redniBrojBombe, brojDostupnihBomba, sifra) {
        return fetch(url + casino.repos.base.serializeGetParams({
                bonusAktivacijaId: bonusAktivacijaId,
                redniBrojBombe: redniBrojBombe,
                brojDostupnihBomba: brojDostupnihBomba,
                sifra:sifra
            }), { credentials: repos.base.credentials })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }
}();